import React, { Component } from 'react'

import NavBar from './../NavBar'
import Footer from './../Footer'

import './Base.css';

let baseLayout = (Component) => {

    class Base extends Component {
    
      render() {
        return (
          <div className="shared-layouts-base">
            <main>

              <NavBar/>
              
              {/*  <Notifications /> */}

              <Component {...this.props}/>

              <Footer />
            </main>
    
          </div>
        );
      }
    }
    
    Base.displayName = 'SharedLayoutsBase';
    Base.propTypes = {};
    Base.defaultProps = {};

    return Base;
}

export default baseLayout;


// WEBPACK FOOTER //
// ./src/components/shared/layouts/Base.js